// extracted by mini-css-extract-plugin
export default {"container":"Header_container__bSG+6","logo":"Header_logo__2dwLZ"};